import router from 'sky-engine/router'
// const component = {
//   render(h) {
//     return h('router-view')
//   }
// }

/**
 * noAuth:true                    不受权限控制的
 * parentPath:'/app'              父级路由
 * hidden: true                   如果hidden:true ，在左侧菜单中不展示此项，非必须，模式是显示
 * redirect: noredirect           如果 `redirect:noredirect` 在面包屑导航中，不会高亮此项且不具备路由功能，非必须
 * name:'router-name'             <keep-alive>需要此配置，必须有 而且是唯一的
 * meta : {
    role: ['admin','editor']     权限控制，可以配置多个，如果什么都没有配，默认所有角色都可见的
    title: 'title'               在菜单,面包屑显示的名称
    icon: 'svg-name'             在菜单中显示的svg图标
    noCache: true                页面是否需要缓存，默认是false
  }
 **/

/** 不需要权限控制的菜单 */
export const constantMenuRouterMap = []

/** 需要权限控制的菜单*/
export const asyncMenuRouterMap = [
  {
    path: '/web-manage',
    component: () => import('@/views/articleManage/index'),
    name: 'webManage',
    parentPath: '/app',
    meta: {
      title: 'webManage'
    },
    redirect: {
      name: 'arcticle'
    },
    children: [
      {
        path: 'article-manage',
        component: () => import('@/views/articleManage/index'),
        name: 'articleManage',
        meta: {
          title: 'articleManage'
        },
        redirect: {
          name: 'arcticle'
        },
        children: [
          {
            path: 'article',
            name: 'arcticle',
            component: () => import('@/views/articleManage/article')
          },
          {
            path: 'add-article',
            name: 'addArticle',
            component: () => import('@/views/articleManage/addArticle')
          }
        ]
      },
      {
        path: 'file-manage',
        component: () => import('@/views/fileManage/index'),
        name: 'fileManage',
        meta: {
          title: 'fileManage'
        },
        redirect: {
          name: 'file'
        },
        children: [
          {
            path: 'file',
            name: 'file',
            component: () => import('@/views/fileManage/file')
          }
        ]
      },
      {
        path: '/setting',
        component: () => import('@/views/setting/index'),
        name: 'setting',
        parentPath: '/app',
        redirect: {
          name: 'indexSetting'
        },
        meta: {
          title: 'setting'
        },
        children: [
          {
            path: 'index-setting',
            component: () => import('@/views/setting/indexSetting'),
            name: 'indexSetting',
            meta: {
              title: 'indexSetting'
            }
          },
          {
            path: 'inner-page-setting',
            component: () => import('@/views/setting/innerPageSetting'),
            name: 'innerPageSetting',
            meta: {
              title: 'innerPageSetting'
            }
          }
        ]
      },
      {
        path: '/data-analysis',
        component: () => import('@/views/dataAnalysis/index'),
        name: 'dataAnalysis',
        parentPath: '/app',
        redirect: {
          name: 'contentAnalysis'
        },
        meta: {
          title: 'dataAnalysis'
        },
        children: [
          {
            path: 'content',
            name: 'contentAnalysis',
            component: () => import('@/views/dataAnalysis/contentAnalysis'),
            meta: {
              title: 'contentAnalysis'
            }
          },
          {
            path: 'file',
            name: 'fileAnalysis',
            component: () => import('@/views/dataAnalysis/fileAnalysis'),
            meta: {
              title: 'fileAnalysis'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/software-manage',
    component: () => import('@/views/softwareManage/index'),
    name: 'softwareManage',
    parentPath: '/app',
    meta: {
      title: 'softwareManage'
    },
    redirect: {
      name: 'softwareList'
    },
    children: [
      {
        path: 'software-list',
        name: 'softwareList',
        component: () => import('@/views/softwareManage/softwareList'),
        meta: {
          title: 'softwareList'
        }
      },
      {
        path: 'software-dictionary',
        name: 'softwareDictionary',
        component: () => import('@/views/softwareManage/softwareDictionary'),
        meta: {
          title: 'softwareDictionary'
        }
      }
    ]
  },
  {
    path: '/function-analysis',
    component: () => import('@/views/whitelistManage/index'),
    name: 'functionAnalysis',
    parentPath: '/app',
    meta: {
      title: 'functionAnalysis'
    },
    redirect: {
      name: 'BulletinBoard'
    },
    children: [
      {
        path: 'characteristic-organization',
        component: () => import('@/views/characteristicOrganization/index'),
        name: 'characteristicOrganization',
        meta: {
          title: 'characteristicOrganization'
        },
        redirect: {
          name: 'BulletinBoard'
        },
        children: [
          {
            path: 'bulletin-board',
            name: 'BulletinBoard',
            component: () => import('@/views/characteristicOrganization/bulletinBoard')
          },
          {
            path: 'decentralized-organization-list',
            name: 'decentralizedOrgList',
            component: () => import('@/views/characteristicOrganization/decentralizedOrgList')
          }
        ]
      },
      {
        path: 'active-organization',
        component: () => import('@/views/activeOrganization/index'),
        name: 'activeOrganization',
        meta: {
          title: 'activeOrganization'
        },
        redirect: {
          name: 'activeOrganizationList'
        },
        children: [
          {
            path: 'list',
            name: 'activeOrganizationList',
            component: () => import('@/views/activeOrganization/activeOrganizationList')
          },
          {
            path: 'detail',
            name: 'activeOrganizationDetail',
            component: () => import('@/views/activeOrganization/organizationDetail')
          },
          {
            path: 'behavior-detail',
            name: 'activeOrganizationBehaviorDetail',
            component: () => import('@/views/activeOrganization/behaviorDetail')
          },
          {
            path: 'terminal-behavior-detail',
            name: 'terminalBehaviorDetail',
            component: () => import('@/views/activeOrganization/terminalBehaviorDetail')
          },
          {
            path: 'behavior-terminal-detail',
            name: 'behaviorTerminalDetail',
            component: () => import('@/views/activeOrganization/behaviorTerminalDetail')
          },
          {
            path: 'first-login-behavior-detail',
            name: 'firstLoginBehaviorDetail',
            component: () => import('@/views/activeOrganization/firstLoginBehaviorDetail')
          }
        ]
      },
      {
        path: 'whitelist-manage',
        component: () => import('@/views/whitelistManage/index'),
        name: 'whitelistManage',
        meta: {
          title: 'whitelistManage'
        },
        redirect: {
          name: 'whitelist'
        },
        children: [
          {
            path: 'whitelist',
            name: 'whitelist',
            component: () => import('@/views/whitelistManage/whitelist')
          },
          {
            path: 'whitelist-detail',
            name: 'whitelistDetail',
            component: () => import('@/views/whitelistManage/whitelistDetail')
          }
        ]
      }
    ]
  }
]

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    name: 'login'
  },
  // 开发环境临时路由
  {
    path: '/authredirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/help',
    component: () => import('@/views/help/index'),
    name: 'help',
    redirect: 'helpIndex',
    meta: {
      title: 'helpIndex'
    },
    children: [
      {
        path: 'index',
        name: 'helpIndex',
        component: () => import('@/views/help/pages/index'),
        meta: {
          title: 'help'
        }
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/help/pages/search')
      },
      {
        path: 'content',
        name: 'content',
        component: () => import('@/views/help/pages/content')
      }
    ]
  },
  {
    path: '/',
    redirect: 'app'
  },
  {
    path: '/app',
    component: () => import('@/views/layout'),
    redirect: 'login',
    children: constantMenuRouterMap
  }
]
router.options.routes = router.options.routes.concat(constantRouterMap)
router.addRoutes(constantRouterMap)

export default router
